// Import the Supabase client creation function
import { createClient } from '@supabase/supabase-js';

// Retrieve Supabase configuration from environment variables
// These must be prefixed with REACT_APP_ for Create React App to expose them
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Validate that required environment variables are present
if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Missing Supabase environment variables. Please check your .env.local file contains REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY'
  );
}

// Create a single Supabase client instance for interacting with your database
// This client will be used throughout the application for authentication and data operations
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    // Enable automatic token refresh for better user experience
    autoRefreshToken: true,
    // Persist session across browser refreshes
    persistSession: true,
    // Use localStorage to store the user's session
    storage: window.localStorage,
    // Check for session every 60 seconds
    detectSessionInUrl: true
  }
});

// Optional: Export a helper function to check if user is authenticated
export const isAuthenticated = async () => {
  const { data: { session } } = await supabase.auth.getSession();
  return session !== null;
};

// Optional: Export a helper function to get the current user
export const getCurrentUser = async () => {
  const { data: { user } } = await supabase.auth.getUser();
  return user;
};